import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { company, services } from '../data/content';
import { privacyPolicy, termsOfService } from '../data/legal';
import { LegalModal } from './LegalModal';
import { PhoneIcon, MailIcon, GoogleIcon } from './icons';
type LegalDoc = 'privacy' | 'terms';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc | null>(null);
  return <footer className="w-full border-t border-navy-700 bg-navy-900 py-12" data-id="element-237" data-mp="3ug3fllb8kjas">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-238" data-mp="3991omvfnkca">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-239" data-mp="36msyjwt2ysh">
          <div className="lg:col-span-2" data-id="element-240" data-mp="3ldkf37uxairp">
            <div className="flex items-center gap-3" data-id="element-241" data-mp="3lgosmvua2qv1">
              <img src={company.logo} alt="" className="h-12 w-12 object-contain" data-id="element-242" data-mp="3qc3zh3tvbmhy" />
              <span className="font-display text-lg font-bold tracking-tight text-white" data-id="element-243" data-mp="29yxaz74xfaj6">
                {company.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-navy-200" data-id="element-244" data-mp="2evxbz3mx5n3f">
              20 years of family-owned excellence in pool plaster, tile, coping, spray deck
              repair, and complete backyard remodels.
            </p>
            <p className="mt-4 text-sm font-semibold text-sky-300" data-id="element-245" data-mp="3v8rh5uh1b7xr">
              Licensed · Insured · Honest · Trusted
            </p>
            <a href={company.googleProfileUrl} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex items-center gap-2.5 rounded-md border border-navy-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-sky-300 hover:text-sky-200" data-id="element-246" data-mp="3q7byua68rfj2">
              <GoogleIcon className="h-4 w-4" data-id="element-247" data-mp="huwiqy10k36t" />
              5.0 stars on Google — read our reviews
            </a>
          </div>

          

          <div data-id="element-248" data-mp="qt05tyrnd80q">
            <h2 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-white" data-id="element-249" data-mp="qujm3pdazj2i">
              Contact
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-250" data-mp="mptptzeqg2h2">
              <li data-id="element-251" data-mp="tvmnzb2xs4iq">
                <a href={company.phoneHref} className="flex items-center gap-2.5 text-sm text-navy-100 transition-colors duration-150 ease-out hover:text-sky-300" data-id="element-252" data-mp="tw618ehn64qf">
                  <PhoneIcon className="h-4 w-4 text-sky-300" data-id="element-253" data-mp="13tkc7yksq1bc" />
                  {company.phoneDisplay}
                </a>
              </li>
              <li data-id="element-254" data-mp="18kskuseaxing">
                <a href={company.emailHref} className="flex items-center gap-2.5 break-all text-sm text-navy-100 transition-colors duration-150 ease-out hover:text-sky-300" data-id="element-255" data-mp="18lby3vt0biv5">
                  <MailIcon className="h-4 w-4 shrink-0 text-sky-300" data-id="element-256" data-mp="1hje1gi07qnll" />
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-navy-700 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-257" data-mp="1rhtwgw2d2h0d">
          <p className="text-xs text-navy-300" data-id="element-258" data-mp="3oczo179lsb4g">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <nav aria-label="Legal" className="flex items-center gap-5" data-id="element-259" data-mp="2aevg9zetc08y">
            <button type="button" onClick={() => setOpenDoc('privacy')} className="text-xs font-semibold text-navy-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-sky-300 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400" data-id="element-260" data-mp="2ah824nnoyura">
              Privacy Policy
            </button>
            <span className="h-3 w-px bg-navy-700" aria-hidden="true" data-id="element-261" data-mp="2tdg2pe5rehg9" />
            <button type="button" onClick={() => setOpenDoc('terms')} className="text-xs font-semibold text-navy-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-sky-300 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400" data-id="element-262" data-mp="2pc4mfz8rz8kq">
              Terms of Service
            </button>
          </nav>
        </div>
      </div>

      <AnimatePresence data-id="element-263" data-mp="13y08r60ep2ay">
        {openDoc && <LegalModal document={openDoc === 'privacy' ? privacyPolicy : termsOfService} onClose={() => setOpenDoc(null)} data-id="element-264" data-mp="1414ieiwn4q90" />}
      </AnimatePresence>
    </footer>;
}